import { printf, toText, trimStart } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { singleton, append, contains, fold } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { structuralHash, equals, uncurry2 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { tryParse } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Int32.js";
import { FSharpRef } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { List_except } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Seq2.js";
import { asHtmlMoney } from "../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { DOMAttr, DangerousHtml } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Color_IColor } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.3.0.0/Common.fs.js";

export function UrlHashPrefix(s) {
    const arg = trimStart(s, "/");
    return toText(printf("#%s"))(arg);
}

export function UrlCombine(xs) {
    let clo;
    return fold(uncurry2((clo = toText(printf("%s/%s")), (arg) => {
        const clo_1 = clo(arg);
        return clo_1;
    })), "", xs);
}

export function tryInt(str) {
    let patternInput;
    let outArg = 0;
    patternInput = [tryParse(str, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    if (patternInput[0]) {
        return patternInput[1];
    }
    else {
        return undefined;
    }
}

export function toggle(item, lst) {
    if (contains(item, lst, {
        Equals: equals,
        GetHashCode: structuralHash,
    })) {
        return List_except([item], lst, {
            Equals: equals,
            GetHashCode: structuralHash,
        });
    }
    else {
        return append(singleton(item), lst);
    }
}

export function asMoneySpan(v) {
    const props = [new DOMAttr(0, [new DangerousHtml(asHtmlMoney(v))])];
    return react.createElement("span", keyValueList(props, 1));
}

export const CustomColors_bfsOrange = new Color_IColor(19, ["bfsorange"]);

export function RechartExtensions_bar_radius(radius) {
    return ["radius", radius];
}

export function RechartExtensions_bar_background(value) {
    return ["background", value];
}

export function RechartExtensions_xAxis_stroke(value) {
    return ["stroke", value];
}

export function RechartExtensions_yAxis_stroke(value) {
    return ["stroke", value];
}

export function RechartExtensions_yAxis_tick(value) {
    return ["tick", value];
}

export function RechartExtensions_tooltip_cursor(value) {
    return ["cursor", value];
}

export function RechartExtensions_tooltip_labelFormatter(value) {
    return ["labelFormatter", value];
}

//# sourceMappingURL=Helpers.fs.js.map
